export default {
    dbVersion: 4,

    init() {
    },

    getTableName(table) {
        return `DB_${this.dbVersion}_${table}`;
    },

    save(table, data) {
        localStorage.setItem(this.getTableName(table), JSON.stringify(data));
    },

    restore(table) {
        this.clearOldDBs(table);
        return JSON.parse( String(localStorage.getItem(this.getTableName(table))) ) || [];
    },

    remove(table) {
        localStorage.removeItem(this.getTableName(table));
    },

    clearOldDBs(table) {
        for (let i = 1; i < this.dbVersion; i++) {
            localStorage.removeItem(`DB_${i}_${table}`);
        }
    },
};